import Vue from 'vue';

export const projectEventTypeDetailsService = {
  async fetchProjectEventType(referenceNumber) {
    return Vue.axios
      .get(`/projects/event-types/${referenceNumber}`)
      .then(response => response.data);
  },

  async fetchProjectEventTypeAttachments(referenceNumber) {
    return Vue.axios
      .get(`/projects/event-types/${referenceNumber}/attachments`)
      .then(response => response.data);
  },

  async fetchProjectTools(referenceNumber) {
    return Vue.axios.get(`/projects/${referenceNumber}/tools`).then(response => response.data);
  },

  async updateProjectEventType(eventTypeData) {
    return Vue.axios
      .put(`/projects/event-types/${eventTypeData.referenceNumber}`, eventTypeData.updates)
      .then(response => response.data);
  }
};
